import React from "react";
import { Form } from "semantic-ui-react";
import { TiptapEditor } from "../../TiptapEditor/TiptapEditor";
import { useFormik } from "formik";
import { supportAPI } from "../../../api";
import { initialValues, validationSchema } from "./SupportForm.form";
import { useTranslation } from "react-i18next";
import "./SupportForm.scss";

const supportController = new supportAPI();

export function SupportForm(props) {
  const { onClose, onReload, ticket, accessToken, user } = props;
  const { t } = useTranslation("support");

  // Si no tenemos ticket, es creación
  const isCreation = !ticket;
  const mainButtonText = isCreation
    ? t("form.createButton")
    : t("form.replyButton");

  const formik = useFormik({
    initialValues: initialValues(ticket),
    validationSchema: validationSchema(isCreation),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (isCreation) {
          // CREAR TICKET
          const dataToSend = {
            title: formValue.title,
            description: formValue.description,
            message: formValue.message,
            clientInputId: user.user._id, // Ajusta la ruta si es user.user._id
            clientOutputId: user.user.partner, // Partner ID
            senderRole: user.user.role,
          };
          await supportController.createTicket(accessToken, dataToSend);
        } else {
          // RESPONDER TICKET

          // Escoge user.user si existe, o user en caso contrario
          const actualUser =
            user && user.user && typeof user.user === "object"
              ? user.user
              : user;

          // Ahora construye el payload siempre desde actualUser
          const dataToSend = {
            userId: actualUser._id,
            senderRole: actualUser.role,
            message: formValue.message,
          };

          await supportController.respondTicket(
            accessToken,
            ticket._id,
            dataToSend,
          );
        }

        onReload();
        onClose();
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <Form className="support-form" onSubmit={formik.handleSubmit}>
      {/* Campos solo visibles en creación */}
      {isCreation && (
        <>
          <Form.Field>
            <label>{t("form.titleLabel")}</label>
            <Form.Input
              name="title"
              placeholder={t("form.titlePlaceholder")}
              onChange={formik.handleChange}
              value={formik.values.title}
              error={formik.errors.title}
            />
          </Form.Field>

          <Form.Field>
            <label>{t("form.descriptionLabel")}</label>
            <Form.Input
              name="description"
              placeholder={t("form.descriptionPlaceholder")}
              onChange={formik.handleChange}
              value={formik.values.description}
              error={formik.errors.description}
            />
          </Form.Field>
        </>
      )}

      <Form.Field>
        <label>
          {isCreation ? t("form.initialMessageLabel") : t("form.replyLabel")}
        </label>
        <TiptapEditor
          content={formik.values.message}
          onChange={(newContent) => formik.setFieldValue("message", newContent)}
        />
      </Form.Field>

      <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
        {mainButtonText}
      </Form.Button>
    </Form>
  );
}
